import { Component, OnInit, OnChanges, Input, SimpleChanges, Injector } from '@angular/core';
import { KindBoard } from 'src/utils/enums';
import { InputContract } from '../inputmodels/inputcontract.model';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { InputItem } from '../../inputcommon/inputcommon.class';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-input-value-contract',
    templateUrl: './inputvaluecontract.component.html',
    styleUrls: ['./inputvaluecontract.component.css'],
    standalone: false
})
export class InputValueContractComponent extends PageBase implements OnInit, OnChanges {

  @Input() inputValueContract: InputContract = new InputContract();
  @Input() isHideLoading: boolean;
  inputItem: InputItem = new InputItem();
  startLegend: string;
  endLegend: string;
  percentage: number;
  amountValue: number;
  measuredValue: number;
  kindInsumo: KindBoard = KindBoard.Insumo;

  constructor(public contextApplication: ContextApplication,
              public objInjector: Injector) {
    super(objInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.inputValueContract.id = 0;
    this.inputValueContract.contractedAmountQuantity = 0;
    this.inputValueContract.contractedAmountValue = 0;
    this.inputValueContract.measuredQuantity = 0;
    this.inputValueContract.measuredValue = 0;
    this.inputValueContract.percentageQuantityMeasuredUnderContracted = 0;
    this.inputValueContract.percentageValueMeasuredUnderContracted = 0;
    this.inputValueContract.quantityReleased = 0;
    this.inputValueContract.percentageQuantityReleasedUnderMeasured = 0;
    this.inputValueContract.valueReleased = 0;
    this.inputValueContract.percentageValueReleasedUnderMeasured = 0;
    this.startLegend = '';
    this.endLegend = '';
    this.percentage = 0;
    this.amountValue = 0;
    this.measuredValue = 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inputValueContract) {
      this.validateChartsWithContext();
    }
  }

  async validateChartsWithContext() {
    if (this.contextApplication.currentVision == KindBoard.Insumo.valueOf()) {
      this.startLegend = this.literalsCp?.strMedido;
      this.endLegend = this.literalsCp?.strContratado;
      this.percentage = this.inputValueContract.percentageValueMeasuredUnderContracted;
      this.amountValue = this.inputValueContract.contractedAmountValue;
      this.measuredValue = this.inputValueContract.measuredValue;
    }
    else {
      this.startLegend = this.literalsCp?.strLiberado;
      this.endLegend = this.literalsCp?.strMedido;
      this.percentage = this.inputValueContract.percentageQuantityReleasedUnderMeasured;
      this.amountValue = this.inputValueContract.valueReleased;
      this.measuredValue = this.inputValueContract.measuredValue;
    }
  }

  onReceiveLiterals(): void {}
}
